import { reactive } from "vue";

export const confirmState = reactive({ active: null });

/**
 * Drop-in replacement for ant-design's `Modal.confirm`, called as `this.$confirm(options)`.
 * Supports `title`, `content`, `okText`, `cancelText`, `okType` ("danger" colours the confirm
 * button as error), `onOk` and `onCancel`. The returned promise resolves with `true` when the
 * user confirms. `ConfirmHost.vue` renders the dialog.
 */
export function confirm(options = {}) {
	return new Promise((resolve) => {
		confirmState.active = { ...options, resolve };
	});
}

export default {
	install(app) {
		app.config.globalProperties.$confirm = confirm;
	}
};
